/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upload_An_Image_Or_SpecificatiInputs */

const en_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload an image or specification sheet and the AI will automatically create the listing for you.`)
};

const es_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sube una imagen o una hoja de especificaciones y la IA creará automáticamente el anuncio por ti.`)
};

const fr_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Téléchargez une image ou une fiche de spécifications et l'IA créera automatiquement l'annonce pour vous.`)
};

const de_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lade ein Bild oder Datenblatt hoch und die KI erstellt das Inserat automatisch für dich.`)
};

const ja_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像や仕様書をアップロードすると、AIが自動的に出品情報を作成します。`)
};

const zh_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传图片或规格说明书，AI 将自动为您创建商品信息。`)
};

const ar_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`قم برفع صورة أو ورقة مواصفات وسيقوم الذكاء الاصطناعي بإنشاء الإعلان لك تلقائياً.`)
};

const id_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unggah gambar atau lembar spesifikasi dan AI akan secara otomatis membuat listing untuk Anda.`)
};

const it_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carica un'immagine o una scheda tecnica e l'IA creerà automaticamente l'annuncio per te.`)
};

const ru_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузите изображение или лист спецификаций, и ИИ автоматически создаст для вас объявление.`)
};

const pt_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faça o upload de uma imagem ou folha de especificações e a IA criará automaticamente o anúncio para você.`)
};

const ko_upload_an_image_or_specificati = /** @type {(inputs: Upload_An_Image_Or_SpecificatiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미지 또는 사양서를 업로드하면 AI가 자동으로 상품 정보를 생성해 줍니다.`)
};

/**
* | output |
* | --- |
* | "Upload an image or specification sheet and the AI will automatically create the listing for you." |
*
* @param {Upload_An_Image_Or_SpecificatiInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upload_an_image_or_specificati = /** @type {((inputs?: Upload_An_Image_Or_SpecificatiInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upload_An_Image_Or_SpecificatiInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upload_an_image_or_specificati(inputs)
	if (locale === "es") return es_upload_an_image_or_specificati(inputs)
	if (locale === "fr") return fr_upload_an_image_or_specificati(inputs)
	if (locale === "de") return de_upload_an_image_or_specificati(inputs)
	if (locale === "ja") return ja_upload_an_image_or_specificati(inputs)
	if (locale === "zh") return zh_upload_an_image_or_specificati(inputs)
	if (locale === "ar") return ar_upload_an_image_or_specificati(inputs)
	if (locale === "id") return id_upload_an_image_or_specificati(inputs)
	if (locale === "it") return it_upload_an_image_or_specificati(inputs)
	if (locale === "ru") return ru_upload_an_image_or_specificati(inputs)
	if (locale === "pt") return pt_upload_an_image_or_specificati(inputs)
	return ko_upload_an_image_or_specificati(inputs)
});